import defaultImg from "../../assets/images/SD-default-image.png"
export const imageTypeList = [
  {
    name:'image',
    label:"Profile Image",
    imagePath:defaultImg
  }
]